import { toLogProperties } from "./logProperties";
import { trackAppTrace } from "./monitoring/appInsights";
import { recoverTokenInfo } from "./recoverTokenInfo";
import { SERVICE_NAME } from "./reportEvent";

export type TraceReportOptions = {
  eventName: string;
  properties?: Record<string, unknown>;
};

export const reportTrace = async (message: string, options: TraceReportOptions) => {
  const properties = toLogProperties({
    eventName: options.eventName,
    user: recoverTokenInfo("ibabs-user-id"),
    url: typeof window !== "undefined" ? window.location.href : undefined,
    path: typeof window !== "undefined" ? window.location.pathname : undefined,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    language: typeof navigator !== "undefined" ? navigator.language : undefined,
    mode: import.meta.env.MODE,
    ServiceName: SERVICE_NAME,
    AppVersion: __APP_VERSION__,
    ...options.properties,
  });

  trackAppTrace(message, properties);
};
